import { create } from 'zustand'
import { createJSONStorage, persist } from 'zustand/middleware'

interface FlightSearchStoreActions {
  setLastFlightResults: (params: Record<string, unknown>, route: string) => void
}

interface FlightSearchStoreState {
  lastFlightResultsParams: null | Record<string, unknown>
  lastFlightResultsRoute: null | string
}

export const useFlightSearchStore = create<FlightSearchStoreActions & FlightSearchStoreState>()(
  persist(
    (set) => ({
      lastFlightResultsParams: null,
      lastFlightResultsRoute: null,
      setLastFlightResults: (params, route) => {
        set({ lastFlightResultsParams: params, lastFlightResultsRoute: route })
      },
    }),
    {
      name: 'flight-search',
      storage: createJSONStorage(() => localStorage),
    }
  )
)
